import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import intervalPlural from "i18next-intervalplural-postprocessor";
import countries from "i18n-iso-countries";

// eslint-disable-next-line
i18n.use(intervalPlural)
	.use(LanguageDetector)
	.use({
		// custom scans-loading backend to avoid cache problems by exploiting create-react-app bundle hashing.
		// uses webpack dynamic imports https://webpack.js.org/api/module-methods/#import-1
		type: "backend",
		read(language, namespace, callback) {
			let lang = language.split("-")[0];

			countries.registerLocale(
				require(`i18n-iso-countries/langs/${lang}.json`)
			);
			import(
				/* webpackChunkName: "translations" */
				/* webpackMode: "lazy" */
				`../locales/${language}/${namespace}.json`
			).then(
				res => {
					callback(null, res.default);
				},
				err => {
					callback(err, null);
				}
			);
		}
	})
	.use(initReactI18next)
	.init({
		load: "currentOnly",
		fallbackLng: "en",
		ns: "index",
		defaultNS: "index",
		interpolation: {
			escapeValue: false,
			prefix: "%",
			suffix: "%"
		},
		returnObjects: false,
		react: {
			useSuspense: true,
			transSupportBasicHtmlNodes: true
		},
		debug: process.env.NODE_ENV !== "production"
	});

export const aliases = {
	"fr-CH": "fr",
	"fr-CA": "fr",
	"fr-FR": "fr",
	"en-GB": "en",
	"en-US": "en",
	"en-CA": "en",
	"es-ES": "es",
	"nl-BE": "nl",
	"nl-NL": "nl",
	"de-DE": "de",
	"de-CH": "de"
};

window.i18n = i18n;
export default i18n;
